import Select, { components } from 'react-select'

const SelectField = ({ value, callback, style, opt, search = false }) => {
  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        <span>Not found</span>
      </components.NoOptionsMessage>
    )
  }
  return (
    <Select
      options={opt}
      styles={style}
      placeholder={'Select...'}
      menuPlacement="auto"
      isSearchable={search}
      value={opt?.find((f) => f.value === value) || ''}
      onChange={callback}
      components={{ NoOptionsMessage }}
    />
  )
}

export default SelectField
